import { useState } from 'react'
import { resetPassword, ApiHttpError } from '../../utils/api'

interface PasswordResetProps {
  userId: string
  token: string
  onDone: (password: string) => void
  onCancel: () => void
}

export default function PasswordReset({ userId, token, onDone, onCancel }: PasswordResetProps) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password.length < 8) {
      setError('Password must be at least 8 characters')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }
    setBusy(true)
    setError('')
    try {
      await resetPassword(userId, token, password)
      onDone(password)
    } catch (err) {
      setError(err instanceof ApiHttpError ? err.message : 'Could not reset password')
      setBusy(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--bg-primary)]">
      <div className="w-full max-w-sm px-6">
        <div className="text-center mb-8">
          <span className="text-2xl font-bold text-[var(--accent-teal)]">wlns.app</span>
        </div>
        <h1 className="text-xl font-semibold text-center text-[var(--text-primary)] mb-2">Set a new password</h1>
        <p className="text-sm text-center text-[var(--text-secondary)] mb-4">Choose a new password for your log.</p>

        <form onSubmit={submit} className="space-y-3">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="New password"
            className="w-full px-4 py-3 text-center text-lg"
            autoFocus
            disabled={busy}
          />
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="Confirm new password"
            className="w-full px-4 py-3 text-center text-lg"
            disabled={busy}
          />
          {error && <p className="text-sm text-center text-[var(--bac-danger)]">{error}</p>}
          <button type="submit" disabled={busy} className="w-full btn btn-primary py-3 text-lg">
            {busy ? 'Saving…' : 'Set password & unlock'}
          </button>
        </form>

        <button onClick={onCancel} className="mt-4 w-full text-xs text-[var(--text-secondary)] hover:text-[var(--text-primary)]">
          Back to login
        </button>
      </div>
    </div>
  )
}
